export default class Polygon {
  constructor() {
    this._ = [];
  }
  moveTo(x, y) {
    this._.push([x, y]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(x, y) {
    this._.push([x, y]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-delaunay/src/polygon.js
// module id = 351
// module chunks = 1